'use strict';

function renderModal(markupHtml) {
    var modalId = 'dynamic-content-modal';
    $('#' + modalId).remove();

    var modalHtml = `
        <div class="modal fade" id="${modalId}" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="p-1 p-md-3">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="p-3">${markupHtml}</div>
                    </div>
                </div>
            </div>
        </div>
    `;

    var $modal = $(modalHtml);
    $('body').append($modal);
    $modal.one('hidden.bs.modal', function () {
        $(this).remove();
    });
    $modal.modal('show');
}

function isRelativeUrl(url) {
    if (!url || typeof url !== 'string') {
        return false;
    }

    return /^\/(?!\/)/.test(url);
}

module.exports = {
    init: function () {
        $(document)
            .off('click.dynamicModal')
            .on('click.dynamicModal', '.js-dynamic-modal[data-modal-url]', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var $trigger = $(this);
                var modalUrl = $trigger.attr('data-modal-url');

                if (!isRelativeUrl(modalUrl)) {
                    return;
                }

                $.ajax({
                    method: 'GET',
                    url: modalUrl,
                    success: function (data) {
                        if (!data || !data.success || !data.html) {
                            return;
                        }
                        renderModal(data.html);
                    }
                });
            });
    }
};
